const reports = [
    { name: "Bank Estimation Report", status: "available" },
    { name: "PWD Estimate with Rate Analysis Report", status: "available" },
    { name: "Schedule B", status: "available" }
  ];
  export default reports;